// extracted by mini-css-extract-plugin
export default {"container":"StudentHome_container__TpHmR","tile":"StudentHome_tile__szIAn","tileTop":"StudentHome_tileTop__IwxwN"};